import { render, staticRenderFns } from "./DistributionsModal.vue?vue&type=template&id=b506f3b8&"
import script from "./DistributionsModal.vue?vue&type=script&lang=js&"
export * from "./DistributionsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports